export default ({transaction: {sally_transaction_id = ''} = {}} = {}) =>
  sally_transaction_id;
